export const createFbbOrder = (isFiberPro2b: boolean) => {
	return {
		url: `${isFiberPro2b ? 'order-service/add-fbb' : 'product-orchestration/fbb-account'}`,
		method: 'POST',
	};
};
